__turbopack_context__.v({
  "bulkEdit": "BulkActions-module__AGsxza__bulkEdit",
  "bulkEditButton": "BulkActions-module__AGsxza__bulkEditButton",
  "bulkEditButtonSelected": "BulkActions-module__AGsxza__bulkEditButtonSelected",
  "buttonSpace": "BulkActions-module__AGsxza__buttonSpace",
  "cursorAnchor": "BulkActions-module__AGsxza__cursorAnchor",
});
